// @flow
import React from 'react';
import { intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import GettingStartedPage from '../getting-started/GettingStartedComponent';
import NewProductLayout from '../../common/new-product-layout/NewProductLayoutComponent';
import AnalyticsClient from '../../../../clients/AnalyticsClient';
import productEvents from '../../../../analytics/events/products';

type Props = {
  parentLocation: string | null,
  config: Object,
  location: {
    pathname: string,
  },
};

const FullUploadComponent = (props: Props): Element => (
  <NewProductLayout
    parentLocation={props.parentLocation}
    onBackCallback={() => AnalyticsClient.trackEvent(productEvents.backButtonNewProduct())}
    onCloseCallback={() => AnalyticsClient.trackEvent(productEvents.closeButtonNewProduct())}
  >
    <GettingStartedPage
      config={props.config}
      getStartedCallback={() => AnalyticsClient.trackEvent(productEvents.getStartedButtonNewProduct())}
      guidelinesCallback={() => AnalyticsClient.trackEvent(productEvents.guidelinesNewProduct())}
    />
  </NewProductLayout>
);

FullUploadComponent.displayName = 'FullUploadComponent';

FullUploadComponent.propTypes = {
  config: PropTypes.object.isRequired,
  parentLocation: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

FullUploadComponent.defaultProps = {
  parentLocation: null,
};

FullUploadComponent.contextTypes = {
  intl: intlShape.isRequired,
};

export default FullUploadComponent;
